import React from 'react';
import { IMAGE, VIDEO } from '@yme/atoms/gallery/constants';
import { Image } from '@yme/atoms/image';
import { VideoPlayer } from '@yme/atoms/video-player';
import { buildYoutubeUrl, getYoutubePreview } from '@yme/utils/common';
export function isGalleryEmpty(props) {
    return !props || (!props.images.length && !props.videos.length);
}
export const prepareGalleryData = (videos = [], images = []) => {
    const imageComponents = images.map(({ image }) => ({
        element: (React.createElement(Image, { key: image.src, ...image })),
        id: image.src,
        type: IMAGE,
    }));
    const videoComponents = videos.reduce((acc, { youtubeId, isPlaylistId, previewImage }) => {
        const videoItem = (React.createElement(VideoPlayer, { videoPath: buildYoutubeUrl(youtubeId, isPlaylistId), isAutoStopAllowed: true, isHiddenForKeyboard: true }));
        const thumbnailUrl = previewImage ? previewImage.src : getYoutubePreview(youtubeId, true);
        const videoThumbnail = (React.createElement("img", { src: thumbnailUrl, alt: VIDEO, "data-type": VIDEO }));
        acc.items.push({
            element: videoItem,
            id: youtubeId,
        });
        acc.thumbnails.push({
            element: videoThumbnail,
            id: youtubeId,
        });
        return acc;
    }, {
        items: [],
        thumbnails: [],
    });
    return {
        imagesList: [...videoComponents.items, ...imageComponents],
        lightboxImagesList: [...videoComponents.items, ...imageComponents],
        thumbnailsList: [...videoComponents.thumbnails, ...imageComponents],
        lightboxThumbnails: [...videoComponents.thumbnails, ...imageComponents],
    };
};
